import Swal from 'sweetalert2';

const SwalToast = Swal.mixin({
    position: "top-end",
    grow: "row",
    toast: true,
    showConfirmButton: false,
    timer: 4000
});

const ToastSuccess = (msg) => 
    SwalToast.fire({
        customClass: "toast-success",
        html: `
            <div class='pr-4 py-2 h6 mb-0' style='color: #155724;'>
                <i class='fa fa-check-circle' />
                <span class='ml-2'>
                    ${msg}
                </span>
            </div>`
    });

const ToastInfo = (msg) => 
    SwalToast.fire({
        customClass: "toast-info",
        html: `
            <div class='pr-4 py-2 h6 mb-0' style='color: #0c5460;'>
                <i class='fa fa-info-circle' />
                <span class='ml-2'>
                    ${msg}
                </span>
            </div>`
    });

const ToastWarning = (msg) => 
    SwalToast.fire({
        customClass: "toast-warning",
        html: `
            <div class='pr-4 py-2 h6 mb-0' style='color: #856404;'>
                <i class='fa fa-exclamation-triangle' />
                <span class='ml-2'>
                    ${msg}
                </span>
            </div>`
    });

const ToastDanger = (msg) => 
    SwalToast.fire({
        customClass: "toast-danger",
        html: `
            <div class='pr-4 py-2 h6 mb-0' style='color: #721c24;'>
                <i class='fa fa-exclamation-circle' />
                <span class='ml-2'>
                    ${msg}
                </span>
            </div>`
    });

const Toast = {
    info: ToastInfo,
    success: ToastSuccess,
    warning: ToastWarning,
    danger: ToastDanger,
}

export default Toast;